import React from 'react';
import logo from '../Photos/logo.svg';
import Navigationbar from './Navigationbar';
import HeaderMarquee from './headermarque';

const Header = () => {
  return (
    <header className="sticky-top border-bottom" style={{backgroundColor:"white"}}>
      {/* Top Info Bar - Desktop Only */}
      <div className='container-xxl'>
      <div className="bg-white d-none d-md-block py-2">
        <div className="container-fluid px-4 d-flex justify-content-between align-items-center">
          {/* Logo Section */}
          <div className="d-flex align-items-center">
            <img 
              src={logo} 
              alt="Thirupathi Documentation" 
              style={{ height: "75px", width: "auto", objectFit: "contain" }} 
            />
          </div>

          {/* Contact Details Section */}
          <div className="d-flex gap-5">
            <div className="d-flex flex-column border-end pe-4">
              <span className="fw-bold text-dark mb-0" style={{ fontSize: '0.85rem' }}>
                DOCUMENTS SUPPORT
              </span>
              <span className="text-primary fw-semibold" style={{ fontSize: '0.9rem' }}>
                +91 73394 89005
              </span>
              <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                Mon-Fri | 9AM-7PM (Excl. Holidays)
              </small>
            </div>

            <div className="d-flex flex-column">
              <span className="fw-bold text-dark mb-0" style={{ fontSize: '0.85rem' }}>
                SOFTWARE SUPPORT
              </span>
              <span className="text-primary fw-semibold" style={{ fontSize: '0.9rem' }}>
                +91 93444 45252
              </span>
              <small className="text-muted" style={{ fontSize: '0.7rem' }}>
                Mon-Sat | 9AM-7PM (Excl. Holidays)
              </small>
            </div>
          </div>
        </div>
      </div>
      </div>
      
      {/* Main Navigation */}
      <div className="d-none d-md-block"> <HeaderMarquee  /></div>
      <Navigationbar />
      <div className="d-block d-md-none"> <HeaderMarquee  /></div>
    </header>
  );
};

export default Header;